import { cn } from '@kit/ui/utils';

interface SectionProps {
  id?: string;
  title?: string;
  subtitle?: string;
  description?: string;
  children?: React.ReactNode;
  className?: string;
}

export default function Section({
  id,
  title,
  children,
  className,
}: SectionProps) {
  const sectionId = title ? title.toLowerCase().replace(/\s+/g, '-') : id;
  return (
    <section id={id ?? sectionId}>
      <div className="py-16">
        <div className={cn('container relative', className)}>{children}</div>
      </div>
    </section>
  );
}
